import { render, staticRenderFns } from "./PageObjectsContainer.vue?vue&type=template&id=47025d10&"
import script from "./PageObjectsContainer.vue?vue&type=script&lang=js&"
export * from "./PageObjectsContainer.vue?vue&type=script&lang=js&"
import style0 from "./PageObjectsContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports